<template>
  <div class="personal">
    <!--<van-nav-bar title="会员信息" fixed left-arrow @click-left="goBack" @click-right="onClickRight">-->
    <!--</van-nav-bar>-->
    <div style="padding-top: 0" class="van-content">
      <van-cell-group>
        <div class="van-cell van-hairline userheaderbox">
          <div class="van-cell__title">
            <span>我的头像</span>
          </div>
          <div class="van-cell__value">
            <label for="upfile" class="userheader">
              <!--<img :src="datas.length== 0?'/static/images/userheaderimg.png':datas.memberinfo.user_icon" onerror="src='/static/images/userheaderimg.png'"/>-->
              <img :src="header!=undefined?header:'/static/images/userheaderimg.png'">
            </label>
            <input id="upfile" name="upfile" class="upload" @change='onRead' accept="image/gif,image/jpg,image/jpeg,image/png" type="file" hidden>
          </div>
          <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div>
        <div class="van-cell van-hairline" @click="nicknamePlay()">
          <div class="van-cell__title">
            <span>姓名</span>
          </div>
          <div class="van-cell__value">{{ name }}</div>
        </div>
        <div class="van-cell van-hairline">
          <div class="van-cell__title">
            <span>工号</span>
          </div>
          <div class="van-cell__value">{{ level_name }}</div>
        </div>
        <div class="van-cell van-hairline"  @click="bumenPlay()" >
          <div class="van-cell__title">
            <span>部门</span>
          </div>
          <div class="van-cell__value" v-html="bumen=='null'?'':bumenDatas[bumen].name"></div>
          <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div>
        <div class="van-cell van-hairline" @click="gonghuiPlay()" >
          <div class="van-cell__title">
            <span>所属工会</span>
          </div>
          <div class="van-cell__value"  v-html="gonghui=='null'?'':gonghuiDatas[gonghui].name"></div>
          <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div>
        <div class="van-cell van-hairline" >
          <div class="van-cell__title">
            <span>身份证号码</span>
          </div>
          <div class="van-cell__value">{{ idNum }}</div>
        </div>

        <!--<div class="van-cell van-hairline" @click="birthdayChange()">-->
        <div class="van-cell van-hairline" @click="birthdayChange()">
          <div class="van-cell__title">
            <span>生日</span>
          </div>
          <div class="van-cell__value" v-html="birthday==null?'':birthday"></div>
          <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div>
        <div class="van-cell van-hairline" >
          <div class="van-cell__title">
            <span>手机号码</span>
          </div>
          <div class="van-cell__value">{{ phone }}</div>
        </div>
        <div class="van-cell van-hairline" >
          <div class="van-cell__title">
            <span>工会会员</span>
          </div>
          <div class="van-cell__value">{{ usertype==1?'是':'否' }}</div>
        </div>
        <!--<van-cell to="/user/personal/phone" is-link title="手机号码" :value="phone"/>-->
        <!--<van-cell to="/user/personal/password" is-link title="修改密码"/>-->
      </van-cell-group>
      <!--部门选择-->
      <van-actionsheet v-model="bumenShow" :actions="bumenDatas" cancel-text="取消" />
      <!--工会选择-->
      <van-actionsheet v-model="gonghuiShow" :actions="gonghuiDatas" cancel-text="取消" />
      <!--生日选择-->
      <van-actionsheet v-model="birthdayShow">
        <div>
          <van-datetime-picker
            v-model="currentDate"
            type="date"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="birthdayConfirm"
            @cancel="birthdayCancel"
          />
        </div>
      </van-actionsheet>
    </div>
  </div>
</template>

<script>
  export default {
    name: "index",
    props:['configData','userConfig'],
    data () {
      return {
        nicknameIn:'',
        name:'',
        level_name:'',
        phone:'',
        header:'',
        sex:null,
        birthday:'',
        currentDate: new Date(),
        minDate: new Date(1900,0,1),
        maxDate: new Date(),
        nicknameShow:false,
        birthdayShow:false,
        bumenShow: false,
        gonghuiShow: false,
        idNum:'',
        bumen:'',
        gonghui:'',
        bumenDatas: [],
        gonghuiDatas: [],
        imgs: [],
        imgData: {
          accept: 'image/gif, image/jpeg, image/png, image/jpg',
        }
      }
    },
    computed:{
      usertype(){
        return this.$store.state.userCount.type
      }
    },
    methods: {
      goBack: function () {
        history.back(-1);
      },
      onClickRight() {
        console.log('按钮');
      },
      bumenPlay:function () {
        this.bumenShow = true
      },
      gonghuiPlay:function () {
        this.gonghuiShow = true
      },
      getDatas:function () {
        let _this=this;
        let isUser = localStorage.getItem("BLHuser")
        _this.$api.post('WebApi/Member/Info/index', {token:isUser}, res => {

          _this.header = res.data.data.memberinfo.user_icon
          _this.birthday = res.data.data.memberinfo.birthday
          _this.phone = res.data.data.memberinfo.mobile
          _this.level_name = res.data.data.memberinfo.work_number
          _this.name = res.data.data.memberinfo.name
          _this.idNum = res.data.data.memberinfo.id_card_no
          // _this.bumen = res.data.data.memberinfo.department
          // _this.gonghui = res.data.data.memberinfo.union
          let bumen1=res.data.data.departmentdata;
          for(var i=0;i<bumen1.length;i++){
            let row={ name:bumen1[i].name, value:bumen1[i].id, callback: this.bumenChange };
            if(res.data.data.memberinfo.department==bumen1[i].id){
              _this.bumen=i
            }
            _this.bumenDatas.push(row);
          }
          let gonghui1=res.data.data.member_union_data;
          for(var i=0;i<gonghui1.length;i++){
            let row1={ name:gonghui1[i].name, value:gonghui1[i].id, callback: this.gonghuiChange };
            if(res.data.data.memberinfo.union==gonghui1[i].id){
              _this.gonghui=i
            }
            _this.gonghuiDatas.push(row1);
          }
        })
      },
      bumenChange:function (item) {
        this.bumenShow = false
        let isUser = localStorage.getItem("BLHuser")
        if(item.value != this.bumen){
          const toast = this.$toast.loading({
            mask: true,
            duration: 0
          });
          this.$api.post('WebApi/Member/Info/updateInfo', {token:isUser,department_id:item.value}, res => {
            if(res.data.errCode == '0000'){
              // this.bumen = item.value
              this.bumenDatas.map((maps,index)=>{
                if(item.value==maps.value){
                  this.bumen=index
                }
              })
              toast.clear()
            }else{
              this.$toast(res.data.desc)
            }
          })
        }
      },
      gonghuiChange:function (item) {
        this.gonghuiShow = false
        let isUser = localStorage.getItem("BLHuser")
        if(item.value != this.gonghui){
          const toast = this.$toast.loading({
            mask: true,
            duration: 0
          });
          this.$api.post('WebApi/Member/Info/updateInfo', {token:isUser,union_id:item.value}, res => {
            if(res.data.errCode == '0000'){
              // this.gonghui = item.value
              this.gonghuiDatas.map((maps,index)=>{
                if(item.value==maps.value){
                  this.gonghui=index
                }
              })
              toast.clear()
            }else{
              this.$toast(res.data.desc)
            }
          })
        }
      },
      birthdayChange:function () {
        this.birthdayShow = true
      },
      birthdayConfirm:function () {
        let isUser = localStorage.getItem("BLHuser")
        this.birthdayShow = false
        var y = this.currentDate.getFullYear()
        var m = this.currentDate.getMonth()+1
        var d = this.currentDate.getDate()
        var birthdaydata = y+'-'+m+'-'+d
        const toast = this.$toast.loading({
          mask: true,
          duration: 0
        });
        this.$api.post('WebApi/Member/Info/setMemberBirthday', {token:isUser,birthday:birthdaydata}, res => {
          if(res.data.errCode == '0000'){
            this.birthday = y+'-'+m+'-'+d
            toast.clear()
          }else{
            this.$toast(res.data.desc)
          }
        })
      },
      nicknameConfirm:function () {
        let isUser = localStorage.getItem("BLHuser")
        const toast = this.$toast.loading({
          mask: true,
          duration: 0
        });
        this.$api.post('WebApi/Member/Info/setMemberName', {token:isUser,name:this.nicknameIn}, res => {
          if(res.data.errCode == '0000'){
            this.name = this.nicknameIn
            toast.clear()
          }else{
            this.$toast(res.data.desc)
          }
        })
      },
      birthdayCancel:function () {
        this.birthdayShow = false
      },
      onRead:function (event) {
        let isUser = localStorage.getItem("BLHuser")
        let reader =new FileReader();
        let img1=event.target.files[0];
        let type=img1.type;//文件的类型，判断是否是图片
        let size=img1.size;//文件的大小，判断图片的大小
        if(this.imgData.accept.indexOf(type) == -1){
          this.$toast.alert('请选择我们支持的图片格式！');
          return false;
        }else if(size>3145728){
          this.$toast('请选择3M以内的图片！');
          return false;
        }else{
          const toast = this.$toast.loading({
            mask: true,
            message: '上传中...',
            duration: 0
          });
          var uri = ''
          let form = new FormData();
          form.append('file',img1,img1.name);
          this.$api.file('WebApi/Member/Info/setMemberPic?token='+isUser, form, res => {
            uri = res.data.url
            reader.readAsDataURL(img1);
            var that=this;
            reader.onloadend=function(){
              that.imgs.push(uri);
            }
            this.header = res.data.data.pic
            toast.clear()
          })
        }

      }
    },
    mounted () {
      this.getDatas()
    },
  }
</script>

<style lang="less" scoped>
.personal{
  .nicknameinput{
    width: 250px;
  }
  .van-cell-group{
    background: #fff;
    /*margin-top: 10px;*/
    .van-cell:not(:last-child)::after{
      left: 0;
    }
    .userheaderbox{
      .van-cell__title span,.van-icon{
        line-height: 50px;
      }
      .userheader{
        line-height: 50px;
        display: inline-block;
        vertical-align: top;
        width: 50px;
        border-radius: 50%;
        overflow: hidden;
        img{
          width: 50px;
          height: 50px;
        }
      }
    }
    .userheaderbox::after{
      -webkit-transform: scaleY(.9);
      transform: scaleY(.9);
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/personal/index.vue